"use client";

import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { imageUrl } from "@/util/api/baseUrl";
import { ConvertLink } from "@/util/tools";
import { useDebounce } from "@/util/tools/useDebounce";
import MyImage from "@/util/view/MyImage";
import PaginationView from "@/util/view/PaginationView";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

interface CreatorListType {
  timeStamp: string;
  statusCode: number;
  httpStatus: string;
  message: string;
  data: Data;
}

interface Data {
  count: number;
  rows: Row[];
}

interface Row {
  id: number;
  creator_title: string;
  creator_second_title: string;
  creator_url: string;
  creator_image: string;
  creator_image_alt: string;
}

interface Props {
  data: CreatorListType;
  searchs: string;
}
const CreatorListView = ({ data, searchs }: Props) => {
  const router = useRouter();
  const [search, setSearch] = useState(searchs || "");
  const value = useDebounce(search, 500);
  useEffect(() => {
    const SearchProduct = async () => {
      if (search.trim()) {
        try {
          router.push(`/creator?search=${search}`);
        } catch (error) {
          console.error("Error fetching search results:", error);
        }
      } else {
        router.push("/creator?page=1");
      }
    };
    if (value !== search && value.length > 3) {
      SearchProduct()
    }
  }, [value, search])

  return (
    <div>
      <h1 className="m-4 font-bold text-3xl">سازنده های عطر</h1>
      <Separator className="mb-4" />
      <div className="bg-ebony rounded p-2">
        <Input
          className="bg-white"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="سازنده خود را جستجو کنید"
        />
      </div>
      <Separator className="my-4" />

      <div className="flex flex-wrap justify-center">
        {data?.data?.rows.map((es) => (
          <Link
            href={`/creator/${ConvertLink(es.creator_url)}`}
            key={es.id}
            className="m-1 h-[300px] w-[250px] text-center"
          >
            <div
              className="m-1 h-[250px] w-[250px] text-center"
            >
              <MyImage
                alt={es.creator_image_alt}
                src={es.creator_image}
                height={250}
                width={250}
              />
            </div>
            <div className="border border-ebony rounded">
              <p className="text-sm font-bold">{es.creator_title}</p>
              <p className="text-sm ">{es.creator_second_title}</p>
            </div>
          </Link>
        ))}
      </div>
      <PaginationView total={data?.data?.count} url={""} />
    </div>
  );
};

export default CreatorListView;
